module.exports = __webpack_public_path__ + "img/snkrhud-logo-black.abac20e8.png";